<template>
  <div id="app">
    <router-view  v-if="isRouterAlive"/>
  </div>
</template>

<script>
  import { getRouter,createRouter } from "../bridge/var";
  // import "./style/var";
  export default {
    provide(){
      return{
        reload:this.reload
      }
    },
    data() {
      return {
        activeMenu: {
          fullPath: ""
        },
        isRouterAlive:true
      };
    },
  created() {
      getRouter().then(result => {
        // this.$router.options.routes = result.router;
        this.$router.addRoutes(result.router);
        this.activeMenu.fullPath = this.$route.fullPath;
        this.$store.commit('setRouter', result);
        let nextRoute = ['login'];
        console.log(this.$router)
        if(nextRoute.indexOf(this.activeMenu.fullPath)==-1&&result.menus.length===0){
          console.log('没有路由信息')
           if(this.activeMenu.fullPath.indexOf('/login/u')===-1){
            this.$router.push(`/`);
          }
        }
        if(result.status == '400') {
          this.$router.push(`/`);
        }
      })
      .catch((res)=>{
          console.log("路由访问失败！不存在");
          localStorage.clear();
          this.$router.addRoutes(res.router);
          // window.location.href  = `${window.location.pathname}#/dataSize`;
          window.location.href  = `${window.location.pathname}#/login`;
      })
    },
    mounted(){
      
    },
    methods: {
      reload(){
        //刷新路由
        this.isRouterAlive=false
        this.$nextTick(function(){
          this.isRouterAlive=true
        })
      }
    }
  };
</script>

<style lang="scss">
  @import "./style/var";
</style>
